import { Autocomplete, AutocompleteChangeReason, TextField } from '@mui/material';
import { SyntheticEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { BankEssential } from '../../../store/actions/bank';
import { selectBank } from '../../../store/bank/bank-all-slice';
import { RootState } from '../../../store/reducers';

interface IBankAutoCompleteProps {
    disableClearable: boolean;
    filterBank: string | undefined;
    setFilterBank: (bank: string | undefined) => void;
    setFilterBankName?: (bank: string | undefined) => void | undefined;
}

const BankAutoComplete = ({ disableClearable, filterBank, setFilterBank, setFilterBankName }: IBankAutoCompleteProps) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const banksState: BankEssential[] = useSelector((state: RootState) => state.banksUser.list);
    const [bankListOptions, setBankListOptions] = useState<[] | { label: string; value: string }[]>([]);
    const [banksOptionSelected, setBankOptionSelected] = useState<{ label: string; value: string } | null>(null);

    useEffect(() => {
        const arrayBanksOption: { label: string; value: string }[] = [];
        banksState?.map((bank: BankEssential) => {
            arrayBanksOption.push({
                label: bank.name,
                value: bank.id
            });
            return arrayBanksOption;
        });

        setBankListOptions(arrayBanksOption);
    }, [banksState]);

    useEffect(() => {
        if (!filterBank) {
            setBankOptionSelected(null);
        }

        if (!banksState) return;

        if (filterBank) {
            const selectedBank: BankEssential | undefined = banksState?.find((bank: BankEssential) => bank.id === filterBank);
            if (selectBank) dispatch(selectBank(selectedBank));
        }
        const bankElement: BankEssential | undefined = banksState?.find((bank: BankEssential) => bank.id === filterBank);

        setBankOptionSelected(
            bankElement
                ? {
                      label: bankElement.name,
                      value: bankElement.id
                  }
                : null
        );
    }, [banksState, filterBank]);

    return (
        <Autocomplete
            disablePortal
            disableClearable={disableClearable}
            id="combo-box-banks"
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            value={banksOptionSelected}
            onInputChange={(event: SyntheticEvent<Element, Event>, value: string, reason: AutocompleteChangeReason) => {
                if (reason === 'clear') {
                    setFilterBank(undefined);
                    if (setFilterBankName) {
                        setFilterBankName(undefined);
                    }
                    return;
                }
            }}
            inputValue={banksOptionSelected?.label || ''}
            options={bankListOptions}
            sx={{ width: '100%', minWidth: '140px' }}
            renderInput={(params) => <TextField {...params} label={t('bank', { ns: 'common' })} InputLabelProps={{ shrink: true }} variant="standard" />}
            onChange={(event: SyntheticEvent<Element, Event>, value: { label: string; value: string } | null, _reason: AutocompleteChangeReason) => {
                setFilterBank(value?.value ?? undefined);

                if (setFilterBankName) {
                    setFilterBankName(value?.label ?? undefined);
                }
            }}
        />
    );
};

export default BankAutoComplete;
